import React from "react";
import "./article.css";

const Article = ({ imgUrl, date, text, description, link, author }) => (
  <article
    className="gpt3__blog-container_article"
    data-aos="zoom-in-up"
    data-aos-duration="1000"
  >
    <div className="gpt3__blog-container_article-image">
      <img src={imgUrl} alt="blog_image" />
    </div>
    <div className="gpt3__blog-container_article-content">
      <div>
        <small>{author}</small>
        <p>Posted on {date}</p>

        <h3>{text}</h3>
        <p>{description}</p>
      </div>
      <a href={link}>Read Full Article</a>
    </div>
  </article>
);

export default Article;
